import React from 'react';
import { Link } from 'react-router-dom';

function DashboardGuide() {
  return (
    <div className="docs-content">
      <h1>Dashboard Guide</h1>
      <p className="docs-lead">
        The SignTada dashboard is your central place to manage documents, templates, webhooks, and settings. This guide describes each section and who can access it.
      </p>

      <h2>Overview (Home)</h2>
      <p>
        The main dashboard shows key metrics: total document requests, signed count, pending count, and completion rate. Charts and tables give you recent activity and top recipients. Quick actions let you start a <strong>New Request</strong> or jump to <strong>Templates</strong>. Your organization’s credit balance is displayed here. Super Admins can switch the view between “All Companies” and a specific company to see stats and data scoped accordingly.
      </p>

      <h2>Documents</h2>
      <p>
        The Documents list shows every signing request you have access to. Use filters: <strong>All</strong>, <strong>Signed</strong>, <strong>Pending</strong>, or <strong>Rejected</strong>. Each row shows the document name, overall status, and per-recipient signing status. Open a row to see details, resend links, or download the signed PDF and audit trail once all required signatures are collected.
      </p>

      <h2>New Request</h2>
      <p>
        Create a new document signing request. Upload a PDF or select a template, then add recipients by email. Place signature and optional text fields on the document. You can enable email notifications, set an expiry date, and optionally require OTP verification or location/face capture for signers. Submit to send; recipients receive a link to sign or reject.
      </p>

      <h2>Templates</h2>
      <p>
        Templates save time when you send the same type of document repeatedly. Create a template from a base PDF, define signature and text field positions and assign roles (e.g. “Signer 1”, “Signer 2”). When creating a new request, choose a template and fill in recipient emails; field positions are already set.
      </p>

      <h2>Webhooks</h2>
      <p>
        <em>Admins and Super Admins only.</em> Configure a webhook URL and optional headers so SignTada can send event notifications to your server (e.g. request created, document signed, rejected). View delivery logs and resend failed deliveries (subject to rate limits). Useful for keeping your backend in sync with signing events.
      </p>

      <h2>Settings</h2>
      <p>
        Under Settings you can manage your profile, and depending on your role: <strong>API keys</strong> (get the key to use in the <code>X-API-Key</code> header), <strong>branding</strong> (logo, colors, theme for your organization), and for Super Admins, <strong>companies</strong> and <strong>credits</strong>. The documentation tab opens this docs site in a new window and always uses the default yellow-and-black theme.
      </p>

      <p>
        <Link to="/user-roles">← User Roles</Link> · <Link to="/signing-flow">Signing Flow →</Link>
      </p>
    </div>
  );
}

export default DashboardGuide;
